"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var Chip_1 = __importDefault(require("@mui/material/Chip"));
var colors_1 = require("../ThemeProvider/colors");
var react_2 = __importDefault(require("react"));
var styles_1 = require("./styles");
__exportStar(require("@mui/material/Chip"), exports);
var Chip = function (_a) {
    var avatar = _a.avatar, classes = _a.classes, className = _a.className, clickable = _a.clickable, _b = _a.color, color = _b === void 0 ? 'primary' : _b, testid = _a["data-testid"], disabled = _a.disabled, icon = _a.icon, label = _a.label, onClick = _a.onClick, onDelete = _a.onDelete, size = _a.size, skipFocusWhenDisabled = _a.skipFocusWhenDisabled, style = _a.style, sx = _a.sx, _c = _a.variant, variant = _c === void 0 ? 'outlined' : _c, ariaLabel = _a["aria-label"];
    var _d = __read((0, react_1.useState)(false), 2), clicked = _d[0], setClicked = _d[1];
    var getVariant = function (clicked) {
        if (variant === 'filled') {
            return clicked ? 'outlined' : 'filled';
        }
        else
            return clicked ? 'filled' : 'outlined';
    };
    var getClickable = function () {
        if (clickable !== undefined) {
            return clickable;
        }
        if (onClick) {
            return true;
        }
        else {
            return false;
        }
    };
    var createDataTestId = function (id) {
        if (id !== undefined) {
            return "chip:".concat(id);
        }
        return 'chip';
    };
    var variantColorMap = {
        outlined: {
            default: colors_1.tannerGray['200'],
            primary: colors_1.tannerGray['200'],
            secondary: colors_1.tannerGray['200'],
            error: colors_1.tannerSemantic.error['100'],
            info: colors_1.tannerSemantic.info['100'],
            success: colors_1.tannerSemantic.success['100'],
        },
        filled: {
            default: colors_1.tannerSemantic.info['300'],
            primary: colors_1.tannerSemantic.info['300'],
            secondary: colors_1.tannerSemantic.info['300'],
            error: colors_1.tannerSemantic.error['300'],
            info: colors_1.tannerSemantic.info['300'],
            success: colors_1.tannerSemantic.success['300'],
        },
    };
    var getCloseColor = function () {
        return getVariant(clicked)
            ? variantColorMap.outlined[color] || colors_1.tannerGray['200']
            : variantColorMap.filled[color] || colors_1.tannerSemantic.info['300'];
    };
    return (react_2.default.createElement(Chip_1.default, { avatar: avatar, classes: classes, className: className, clickable: getClickable(), color: color, "data-testid": createDataTestId(testid), deleteIcon: react_2.default.createElement(styles_1.StyledChipButton, { tabIndex: -1, closeColor: getCloseColor() },
            react_2.default.createElement(styles_1.StyledClose, { titleAccess: "Remove", "data-testid": "".concat(createDataTestId(testid), ":deleteicon") })), disabled: disabled, icon: icon, label: label, onClick: function (e) {
            e.preventDefault();
            if (onClick) {
                setClicked(!clicked);
                onClick(e);
            }
        }, onDelete: onDelete, size: size, skipFocusWhenDisabled: skipFocusWhenDisabled, style: style, sx: sx, variant: getVariant(clicked), "aria-label": ariaLabel }));
};
exports.default = Chip;
//# sourceMappingURL=Chip.js.map